import { MigrationInterface, QueryRunner } from 'typeorm'

export class AddReservationSource1717149894265 implements MigrationInterface {
	name = 'AddReservationSource1717149894265'

	public async up(queryRunner: QueryRunner): Promise<void> {
		await queryRunner.query(`CREATE TYPE "public"."reservation_source_enum" AS ENUM('widget', 'admin', 'google')`)
		await queryRunner.query(
			`ALTER TABLE "reservation" ADD "source" "public"."reservation_source_enum" NOT NULL DEFAULT 'admin'`,
		)
	}

	public async down(queryRunner: QueryRunner): Promise<void> {
		await queryRunner.query(`ALTER TABLE "reservation" DROP COLUMN "source"`)
		await queryRunner.query(`DROP TYPE "public"."reservation_source_enum"`)
	}
}
